export default{
	strategy:'削峰填谷策略',
	pcspower:'PCS功率',
    plannedPower:'计划功率',
	powerDifference:'功率差值',
	selfConsumptionPrediction:'自耗电预测',
	historicalPowerQuery:'历史功率查询',
	starttime:'开始时间',
	endtime:'结束时间',
	search:'查询',
	nodata:'暂无数据'
}


// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/strategyOptimize.js